import { IHeaderOption } from './HeaderRadio';
import { ClassEnum, COLOR_SCHEME_OPTIONS, DISPLAY_TYPE_OPTIONS } from '@/constants/enum';
import { useDispatch, useSelector } from 'react-redux';
import { widgetSettingSelector } from '@/redux/slice/widget.slice';
import { handleSavePreviewOptionSettings, previewOptionSelector } from '@/redux/slice/preview.slice';
import Dropdown from '../../components/Dropdown';
import { DEFAULT_DARK_BACKGROUND_COLOR, DEFAULT_DARK_COLOR } from '@/constants';
import { rgbaToHex } from '@/helpers';

interface IProps {
  options: IHeaderOption[];
}

const HeaderDropdown = ({ options }: IProps) => {
  const widgetSettings = useSelector(widgetSettingSelector);
  const previewOptions = useSelector(previewOptionSelector);
  const dispatch = useDispatch();

  const renderOption = (option: IHeaderOption) => (
    <div key={`methods-select-${option.value}`} className={ClassEnum.HeaderDropdownContentItem}>
      {widgetSettings.widgetMethods.displayType !== DISPLAY_TYPE_OPTIONS.TEXT && (
        <option.icon
          className={ClassEnum.HeaderDropdownContentItemIcon}
          style={{
            width: (24 * widgetSettings.sizes.labelFontSize) / 14,
            height: (24 * widgetSettings.sizes.labelFontSize) / 14,
          }}
        />
      )}
      <div className={ClassEnum.HeaderDropdownContentItemText} style={{ fontSize: `${widgetSettings.sizes.labelFontSize}px` }}>
        {widgetSettings.widgetMethods.displayType !== DISPLAY_TYPE_OPTIONS.ICON ? option.label : null}
      </div>
    </div>
  );

  return (
    <Dropdown
      options={options.map((method) => ({ value: method.value, label: renderOption(method) }))}
      value={previewOptions.methods.find((item) => item.selected)?.key}
      onChange={(value) => {
        dispatch(
          handleSavePreviewOptionSettings({
            methods: previewOptions.methods.map((method) =>
              method.key === value ? { ...method, selected: true } : { ...method, selected: false },
            ),
          }),
        );
      }}
      color={widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK ? rgbaToHex(DEFAULT_DARK_COLOR) : ''}
      backgroundColor={widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK ? rgbaToHex(DEFAULT_DARK_BACKGROUND_COLOR) : ''}
      borderRadius={widgetSettings.widgetMethods.borderRadius}
      iconDropdownExpandOpacity={widgetSettings.colorScheme === COLOR_SCHEME_OPTIONS.DARK ? 1 : 0.5}
    />
  );
};

export default HeaderDropdown;
